import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CreateEntitiesUseCaseInterface } from 'domain/usecases';

export class RemoteCreateEntities implements CreateEntitiesUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<CreateEntitiesUseCaseInterface.Result>,
  ) {}

  async execute(
    params: CreateEntitiesUseCaseInterface.Params,
  ): Promise<CreateEntitiesUseCaseInterface.Result> {
    const {
      address: { cityId, ...restAddress },
      ...rest
    } = params;
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: this.url,
      body: { ...rest, address: { ...restAddress, cityId: Number(cityId) } },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
